import React, { Component } from 'react';
import '../../styles/components/tooltip.scss';

class Tooltip extends Component {
  render() {
    const { icon: Icon, tooltipText, onClick, size = 18, color = '#1b8f9b' } = this.props;

    return (
      <div className="tooltip-container">
        <button className="info-button" onClick={onClick}>
          {Icon && <Icon size={size} color={color} />}
        </button>
        <span className="tooltip-text">{tooltipText}</span>
      </div>
    );
  }
}

export default Tooltip;
